import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './Languages.module.scss';
import flagGermany from './flag_germany.png';
import * as actions from 'store/actions/index';
import { isNLW, isTdk } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

class Languages extends Component {

    constructor(props) {
        super(props);
        this.state = { language: 'de', selected: false, flag: flagGermany };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (event) => {
        this.props.selectLanguage(event.target.value);
    }

    showFlag = (flag) => {
        if (!isNLW() && !this.props.minimalist) return <img className={classes.Icon} src={flag} />
    }

    render() {
        const languages = this.props.config.languages;
        let imgName = this.props.language;
        //if (isTdk() && imgName == 'en') imgName = 'us';
        if (isTdk()) return null;
        let flag = "img/flags/" + imgName + ".png";
        const options = [];
        Object.keys(languages).forEach((key) => {
            let name = this.props.minimalist ? languages[key].shortName : languages[key].name;
            options.push(<option key={key} value={languages[key].value}>{name}</option>);
        });

        return (
            <div>
                <form className={[classes.Languages, (this.props.minimalist && classes.minimalist)].join(' ')}>
                    {this.showFlag(flag)}
                    {/*!this.props.minimalist && <img className={classes.Icon} src={flag} />*/}
                    <select className={classes.LanguagesSelect} style={isNLW() ? { width: "80%" } : null} value={this.props.language} onChange={this.handleChange}>
                        {options}
                    </select>

                    <br />
                </form>
            </div>
        )
    }
}

let mapStateToProps = (state) => {
    return {
        language: state.ui.language,
        config: state.ui.config
    }
}

let mapDispatchToProps = (dispatch) => {
    return {
        selectLanguage: (lang) => dispatch(actions.selectLanguage(lang))
    }
}

let LanguagesContainer =
    connect(mapStateToProps, mapDispatchToProps)(Languages);

export default LanguagesContainer;


